import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";
import notifyingAction from "domainActions/notifyingAction";
import Store from "logic/local-storage/Store";
import {
  createPublicNotification,
  deletePublicNotification,
  updatePublicNotification,
  fetchPublicNotifications
} from "./PublicNotificationsAPI";
const LOCAL_STORAGE = "gl-notifications";
const AUTOLOAD_TIME_MS = 5e3;
const handleCreatePublicNotifications = notifyingAction({
  action: createPublicNotification,
  success: () => ({
    message: "Public Notification successfully created!"
  }),
  error: (error) => ({
    message: `Error Creating: ${error}`
  })
});
const handleDeletePublicNotifications = notifyingAction({
  action: deletePublicNotification,
  success: () => ({
    message: "Public Notification successfully deleted!"
  }),
  error: (error) => ({
    message: `Error Deleting: ${error}`
  })
});
const handleUpdatePublicNotifications = notifyingAction({
  action: updatePublicNotification,
  success: () => ({
    message: "Public Notification successfully edited!"
  }),
  error: (error) => ({
    message: `Error Editing: ${error}`
  })
});
const queryKey = ["customization", "notifications"];
const fetchDismissedNotifications = () => {
  var _a;
  return Promise.resolve(new Set((_a = Store.get(LOCAL_STORAGE)) != null ? _a : []));
};
const usePublicNotifications = () => {
  const { data: notifications = {} } = useQuery({
    queryKey,
    queryFn: fetchPublicNotifications,
    refetchInterval: AUTOLOAD_TIME_MS
  });
  const { data: dismissedNotifications } = useQuery({
    queryKey: [...queryKey, "dismissed"],
    queryFn: fetchDismissedNotifications
  });
  const queryClient = useQueryClient();
  const _reload = () => {
    queryClient.invalidateQueries({
      queryKey
    });
  };
  const { mutateAsync: onCreatePublicNotification } = useMutation({
    mutationFn: handleCreatePublicNotifications,
    onSuccess: _reload
  });
  const { mutateAsync: onDeletePublicNotification } = useMutation({
    mutationFn: handleDeletePublicNotifications,
    onSuccess: _reload
  });
  const { mutateAsync: _onUpdatePublicNotification } = useMutation({
    mutationFn: handleUpdatePublicNotifications,
    onSuccess: _reload
  });
  const onUpdatePublicNotification = useCallback(
    (id, notification) => _onUpdatePublicNotification({ id, notification }),
    [_onUpdatePublicNotification]
  );
  const onDismissPublicNotification = (id) => {
    const dismissed = Array.from(dismissedNotifications.add(id));
    Store.set(LOCAL_STORAGE, dismissed);
    _reload();
  };
  return {
    notifications,
    dismissedNotifications,
    onCreatePublicNotification,
    onDeletePublicNotification,
    onDismissPublicNotification,
    onUpdatePublicNotification
  };
};
export default usePublicNotifications;
